import Modal from 'antd/lib/modal'
import Button from 'antd/lib/button'
import Flex from 'antd/lib/flex'
import styles from './ProctoringExitConfirmModal.module.less'

interface ProctoringExitConfirmModalProps {
    open: boolean
    exitLabel: string
    onCancel: () => void
    onConfirm: () => void
}

export const ProctoringExitConfirmModal = ({
    open,
    exitLabel,
    onCancel,
    onConfirm,
}: ProctoringExitConfirmModalProps) => {
    const label = exitLabel.toLowerCase()
    return (
        <Modal
            open={open}
            centered
            closable={false}
            maskClosable={false}
            footer={null}
            width={400}
            zIndex={1100}
            onCancel={onCancel}
            rootClassName={styles.exitConfirmModal}
            data-testid="proctoring-exit-confirm-modal"
        >
            <Flex vertical gap={16}>
                <h3>{`Exit ${exitLabel}?`}</h3>
                <Flex vertical gap={4}>
                    <h4>You will lose your attempt</h4>
                    <p>
                        {`If you exit now, you'll lose your ${label} attempt. You'll need to restart the ${label} when you return.`}
                    </p>
                </Flex>
                <Flex gap={8}>
                    <Button block onClick={onCancel} data-testid="proctoring-exit-confirm-cancel">
                        Cancel
                    </Button>
                    <Button
                        block
                        type="primary"
                        danger
                        onClick={onConfirm}
                        data-testid="proctoring-exit-confirm-exit"
                    >{`Exit ${exitLabel}`}</Button>
                </Flex>
            </Flex>
        </Modal>
    )
}
